'use strict';

var privatePropertyAccessor = require('../../common/internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('timers');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/var/_timers.js
// module id = 301
// module chunks = 0